module.exports = __webpack_public_path__ + "img/trash.7f0a6f75.svg";